// @ts-nocheck
import {useMemo, useCallback} from 'react'
import {Column} from 'react-table'
import {HotelCustomHeader} from './HotelCustomHeader'
import {Hotel} from '../../core/_models'
import { HotelInfoCell } from '../../../../../../_dashboard/partials/components/commonColumns/HotelCell'
import { HotelActionsCell } from './HotelActionsCell'
import { useIntl } from 'react-intl'
import { useAuth } from '../../../../../modules/auth'
import { ToggleButton } from '../../../../pages-managment/pages-details/commun-component/ToggleButton'
import { patchOne } from '../../../../../services/common_requests'
import { toast } from 'react-toastify'

const useHotelsColumns = (): ReadonlyArray<Column<Hotel>> => {
  const intl = useIntl()
  const {auth} = useAuth()

  const handleToggleChange = useCallback(async (id: string, newIsActive: boolean) => {
    if (auth?.role !== 'ROLE_SUPER_ADMIN') {
      return
    }
    try {
      const response = await patchOne({isActive: newIsActive}, `/hotels/${id}/status`)
      if (response?.payload?.code === 2021) {
        toast.success(intl.formatMessage({id: 'ADMIN.COMMON.SUCCESS.HOTEL_UPDATED_SUCCESSFULLY'}), {
          position: 'top-right',
          autoClose: 4000,
        })
      }
    } catch (error) {
      toast.error(intl.formatMessage({id: 'ADMIN.COMMON.ERROR.HOTEL_UPDATED'}), {
        position: 'top-right',
        autoClose: 4000,
      })
    }
  }, [auth?.role, intl])

  return useMemo(() => [
    {
      Header: (props) => (
        <HotelCustomHeader
          tableProps={props}
          title={intl.formatMessage({id: 'COLUMNS.ID'})}
          className='min-w-125px'
        />
      ),
      accessor: 'hotel_id',
    },
    {
      Header: (props) => (
        <HotelCustomHeader
          tableProps={props}
          title={intl.formatMessage({id: 'COLUMNS.NAME'})}
          className='min-w-125px'
        />
      ),
      id: 'name',
      Cell: ({...props}) => <HotelInfoCell hotel={props.data[props.row.index]} />,
    },
    {
      Header: (props) => (
        <HotelCustomHeader
          tableProps={props}
          title={intl.formatMessage({id: 'COLUMNS.CATEGORY'})}
          className='min-w-125px'
        />
      ),
      accessor: 'ratings.title',
      Cell: ({value}: {value: string}) => <span className='text-muted'>{value}</span>,
    },
    {
      Header: (props) => (
        <HotelCustomHeader
          tableProps={props}
          title={intl.formatMessage({id: 'COLUMNS.CITY'})}
          className='min-w-125px'
        />
      ),
      accessor: 'city.name',
      Cell: ({value}: {value: string}) => <span className='text-muted'>{value}</span>,
    },
    {
      Header: (props) => (
        <HotelCustomHeader
          tableProps={props}
          title={intl.formatMessage({id: 'COLUMNS.ADDRESS'})}
          className='min-w-125px'
        />
      ),
      accessor: 'address',
    },
    {
      Header: (props) => (
        <HotelCustomHeader tableProps={props} title='Status' className='min-w-100px' />
      ),
      id: 'isActive',
      Cell: ({row}: any) =>
        auth?.role === 'ROLE_SUPER_ADMIN' ? (
          <ToggleButton
            id={row.original._id}
            isActive={!!row.original.isActive}
            onChange={(id, newValue) => handleToggleChange(id, newValue)}
          />
        ) : (
          <span className={`badge ${row.original.isActive ? 'badge-light-success' : 'badge-light-danger'}`}>
            {row.original.isActive ? 'Active' : 'Inactive'}
          </span>
        ),
    },
    {
      id: 'actions',
      Cell: ({...props}) => <HotelActionsCell id={props.data[props.row.index]._id} />,
    },
  ], [intl, auth?.role, handleToggleChange])
}

export {useHotelsColumns}
